/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ISpinnerStyleProps, ISpinnerStyles, Spinner } from '@fluentui/react/lib/Spinner';
import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { Property } from 'csstype';
import * as React from 'react';
import { getStylist } from 'src/core/themes/luisStylist';

const { styleComponent } = getStylist('LoadingPage');

const FullPageContainer = styleComponent<IStackProps>(Stack)('FullPageContainer', theme => ({
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.pageBackgroundColor,
    zIndex: theme.pageZIndex as Property.ZIndex
}));

const spinnerStyles = classNamesFunction<ISpinnerStyleProps, ISpinnerStyles>()({ circle: { width: 70, height: 70, borderWidth: 5 } });

export const LoadingPage = () => (
    <FullPageContainer verticalFill>
        <Stack horizontalAlign="center" verticalFill tokens={{ padding: '5%' }}>
            <Spinner styles={spinnerStyles} />
        </Stack>
    </FullPageContainer>
);
